import { render } from "./AppIntro.vue?vue&type=template&id=38041949"
import script from "./AppIntro.vue?vue&type=script&lang=js"
export * from "./AppIntro.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__